export type Order = 'asc' | 'desc';

export const isEmpty = (val: unknown) => {
  return val === undefined || val == null || (typeof val === 'string' && val.length <= 0);
};

export function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const orderAfterCompare = comparator(a[0], b[0]);
    if (orderAfterCompare !== 0) return orderAfterCompare;
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}

export function descendingComparator<T>(a: T, b: T, newOrderBy: keyof T) {
  if (isEmpty(a[newOrderBy])) {
    return -1;
  }
  if (isEmpty(b[newOrderBy])) {
    return 1;
  }

  const dateKey = a[newOrderBy] as unknown as string;
  const isDate: boolean = Date.parse(dateKey) > 0;
  if (!isDate && typeof a[newOrderBy] === 'string' && typeof b[newOrderBy] === 'string') {
    const stringValueA = a[newOrderBy] as unknown as string;
    const stringValueB = b[newOrderBy] as unknown as string;
    return (
      -1 *
      stringValueA.localeCompare(stringValueB, 'standard', {
        sensitivity: 'case',
        ignorePunctuation: true,
        numeric: true,
      })
    );
  }

  if (b[newOrderBy] < a[newOrderBy]) {
    return -1;
  }
  if (b[newOrderBy] > a[newOrderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(theOrder: Order, theOrderBy: unknown): (a: unknown, b: unknown) => number {
  return theOrder === 'desc'
    ? (a, b) => descendingComparator(a, b, theOrderBy as never)
    : (a, b) => -descendingComparator(a, b, theOrderBy as never);
}

const dataTableUtils = { stableSort, getComparator };
export default dataTableUtils;
